export const IndexContainer = ({ children }: { children: React.ReactNode }) => {
	return <div className="container mb-20">{children}</div>;
};

export const PillContainer = ({ children }: { children: React.ReactNode }) => {
	return <div className="mt-7 flex flex-wrap gap-2 lg:gap-[0.625rem]">{children}</div>;
};

export const ListingContainer = ({ children }: { children: React.ReactNode }) => {
	return <div className="mt-24 grid gap-10 gap-y-24 lg:mt-48 lg:grid-cols-3 lg:gap-y-48">{children}</div>;
};
